export default __webpack_public_path__ + "static/media/image-cushion-g-w@3x.8b849da6.webp";